var _defineProperty = require("/srv/nobackup/gitlabrunner/builds/JBHNUo9s/2/Terralego/Customers/aguram-deploy/visu-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/srv/nobackup/gitlabrunner/builds/JBHNUo9s/2/Terralego/Customers/aguram-deploy/visu-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/srv/nobackup/gitlabrunner/builds/JBHNUo9s/2/Terralego/Customers/aguram-deploy/visu-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/srv/nobackup/gitlabrunner/builds/JBHNUo9s/2/Terralego/Customers/aguram-deploy/visu-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/srv/nobackup/gitlabrunner/builds/JBHNUo9s/2/Terralego/Customers/aguram-deploy/visu-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/srv/nobackup/gitlabrunner/builds/JBHNUo9s/2/Terralego/Customers/aguram-deploy/visu-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _assertThisInitialized = require("/srv/nobackup/gitlabrunner/builds/JBHNUo9s/2/Terralego/Customers/aguram-deploy/visu-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

(function (a, b) {
  if ("function" == typeof define && define.amd) define(["exports", "@babel/runtime/helpers/objectWithoutProperties", "@babel/runtime/regenerator", "@babel/runtime/helpers/asyncToGenerator", "@babel/runtime/helpers/defineProperty", "react", "prop-types", "./SignupFormRenderer", "./styles.css"], b);else if ("undefined" != typeof exports) b(exports, require("@babel/runtime/helpers/objectWithoutProperties"), require("@babel/runtime/regenerator"), require("@babel/runtime/helpers/asyncToGenerator"), require("@babel/runtime/helpers/defineProperty"), require("react"), require("prop-types"), require("./SignupFormRenderer"), require("./styles.css"));else {
    var c = {
      exports: {}
    };
    b(c.exports, a.objectWithoutProperties, a.regenerator, a.asyncToGenerator, a.defineProperty, a.react, a.propTypes, a.SignupFormRenderer, a.styles), a.SignupForm = c.exports;
  }
})("undefined" == typeof globalThis ? "undefined" == typeof self ? this : self : globalThis, function (a, b, c, d, e, f, g, h) {
  "use strict";

  var l = require("@babel/runtime/helpers/interopRequireDefault");

  function j(a, b) {
    var c = Object.keys(a);

    if (Object.getOwnPropertySymbols) {
      var d = Object.getOwnPropertySymbols(a);
      b && (d = d.filter(function (b) {
        return Object.getOwnPropertyDescriptor(a, b).enumerable;
      })), c.push.apply(c, d);
    }

    return c;
  }

  function k(a) {
    for (var b, c = 1; c < arguments.length; c++) {
      b = null == arguments[c] ? {} : arguments[c], c % 2 ? j(b, !0).forEach(function (c) {
        (0, e.default)(a, c, b[c]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : j(b).forEach(function (c) {
        Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
      });
    }

    return a;
  }

  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = a.SignupForm = void 0, b = l(b), c = l(c), d = l(d), e = l(e), f = l(f), g = l(g), h = l(h);

  var m =
  /*#__PURE__*/
  function (_f$default$Component) {
    _inherits(m, _f$default$Component);

    function m() {
      var _getPrototypeOf2;

      var _this;

      for (var _len = arguments.length, a = new Array(_len), _key = 0; _key < _len; _key++) {
        a[_key] = arguments[_key];
      }

      _classCallCheck(this, m);

      var b;
      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(m)).call.apply(_getPrototypeOf2, [this].concat(a))), b = _assertThisInitialized(_assertThisInitialized(_this)), (0, e.default)(_assertThisInitialized(_assertThisInitialized(_this)), "state", {}), (0, e.default)(_assertThisInitialized(_assertThisInitialized(_this)), "setSignupProperty", function (_ref) {
        var _ref$target = _ref.target,
            a = _ref$target.id,
            b = _ref$target.value;
        return _this.setState(_defineProperty({}, a, b));
      }), (0, e.default)(_assertThisInitialized(_assertThisInitialized(_this)), "submit",
      /*#__PURE__*/
      function () {
        var a = (0, d.default)(
        /*#__PURE__*/
        c.default.mark(function a(d) {
          var e, f, g;
          return c.default.wrap(function (a) {
            for (;;) {
              switch (a.prev = a.next) {
                case 0:
                  return d.preventDefault(), e = b.props.onCreate, f = k({}, b.state), b.setState(function (a) {
                    return {
                      errors: k({}, Object.keys(a).reduce(function (a, b) {
                        return k({}, a, _defineProperty({}, b, !1));
                      }, {})),
                      loading: !0
                    };
                  }), g = b.props.signupAction, a.prev = 5, a.next = 8, g(f);

                case 8:
                  b.setState({
                    done: !0,
                    sentMail: f.email
                  }), e(), a.next = 15;
                  break;

                case 12:
                  a.prev = 12, a.t0 = a["catch"](5), a.t0.data && b.setState({
                    errors: {
                      email: !!a.t0.data.email,
                      password: !!a.t0.data.password
                    },
                    loading: !1
                  });

                case 15:
                case "end":
                  return a.stop();
              }
            }
          }, a, null, [[5, 12]]);
        }));
        return function () {
          return a.apply(this, arguments);
        };
      }());
      return _this;
    }

    _createClass(m, [{
      key: "render",
      value: function render() {
        var a = this.props,
            c = a.render,
            d = (0, b.default)(a, ["render"]),
            e = this.state,
            g = e.errors,
            h = e.done,
            i = e.loading,
            j = e.sentMail,
            l = this.setSignupProperty,
            m = this.submit,
            n = k({
          setSignupProperty: l,
          submit: m,
          errors: g,
          done: h,
          loading: i,
          sentMail: j
        }, d);
        return f.default.createElement(c, n);
      }
    }]);

    return m;
  }(f.default.Component);

  a.SignupForm = m, (0, e.default)(m, "propTypes", {
    render: g.default.func,
    showPassword: g.default.bool,
    onCreate: g.default.func
  }), (0, e.default)(m, "defaultProps", {
    render: h.default,
    showPassword: !0,
    onCreate: function onCreate() {}
  });
  a.default = m;
});